import Drawer from './drawer';

const ContactFormDrawer = class extends Drawer {
    get shouldAppendToBody() { // eslint-disable-line class-methods-use-this
        return false;
    }

    get openFrom() {
        return window.matchMedia('screen and (max-width: 639px)').matches ? 'bottom' : this.getAttribute('open-from') || 'right';
    }

    setInitialPosition() {
        this.style.bottom = this.openFrom === 'bottom' ? '0px' : null;
        this.style.top = this.style.bottom === '' ? '0px' : null;
    }
};

export default ContactFormDrawer;
